export default "__VITE_ASSET__BgqiRCHK__"